import React, { useState } from 'react';
import cn from 'classnames';
import { useInterval } from 'usehooks-ts';

import { useTranslation } from '@lt/localization';
import {
  Loader as LoaderIcon,
  Clock as ClockIcon,
} from '@lt/components/icons-react/rebrand/';

import { getRemainingTime } from 'src/utils/dateUtils';
import { TEST_ID_PRICE_CHEKER_TIMER } from './constants';

import styles from './priceTimer.module.css';

type Props = {
  lastUpdated: number;
  timeout: number;
  fetching: boolean;
};

const PriceTimer = ({ timeout, lastUpdated, fetching }: Props) => {
  const [remainingTime, setRemainingTime] = useState(
    lastUpdated + timeout - Date.now(),
  );
  const { t } = useTranslation();
  const isLoading = fetching || remainingTime < 0;

  useInterval(() => {
    setRemainingTime(lastUpdated + timeout - Date.now());
  }, 1000);

  return (
    <div className={styles.container} data-testid={TEST_ID_PRICE_CHEKER_TIMER}>
      {isLoading ? (
        <>
          <LoaderIcon className={cn(styles.icon, styles.loader)} />
          <div className={styles.text}>
            {t('hotel.searcherTimer', { context: 'update' })}
          </div>
        </>
      ) : (
        <>
          <div className={styles.text}>
            {t('checkout.billInfo.priceChecker')}{' '}
          </div>
          <ClockIcon className={styles.icon} />
          <div className={styles.text}>{getRemainingTime(remainingTime)}</div>
        </>
      )}
    </div>
  );
};

export default PriceTimer;
